<template>
  <div class="navbar-information flex items-stretch text-chplus-regular">
    <div
      class="flex-1 text-left"
      :class="{
        'border-b-2 lg:border-b-2px border-nav-light': activeTab > 0,
        'font-bold': activeTab === 1
      }"
    >
      <div>
        <router-link :to="{ name: 'our-system' }" replace>{{
          $t("components.nav.navbar_misc_1.tab_our_system")
        }}</router-link>
      </div>
    </div>
    <div
      class="flex-1 text-center"
      :class="{
        'border-b-2 lg:border-b-2px border-nav-light': activeTab > 1,
        'font-bold': activeTab === 2
      }"
    >
      <router-link :to="{ name: 'voting-instructions' }" replace>{{
        $t("components.nav.navbar_misc_1.tab_voting_instructions")
      }}</router-link>
    </div>

    <div
      class="flex-1 text-right"
      :class="{
        'border-b-2 lg:border-b-2px border-nav-light': activeTab > 2,
        'font-bold': activeTab === 3
      }"
    >
      <div>
        <router-link :to="{ name: 'get-involved' }" replace>{{
          $t("components.nav.navbar_misc_1.tab_get_involved")
        }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  computed: {
    activeTab() {
      switch (this.$route.name) {
        case "our-system":
          return 1;
        case "voting-instructions":
          return 2;
        case "get-involved":
          return 3;
        default:
          return 0;
      }
    }
  }
};
</script>

<style scoped>
.navbar-information {
  box-sizing: border-box;
  padding: 0 2.25rem;
  height: 100%;
  line-height: 1.25em;
}
.navbar-information a {
  line-height: 1em;
  vertical-align: baseline;
}
@media screen and (min-width: 768px) {
  .navbar-information {
    padding: 0 3.7rem;
  }
}
</style>
